import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EmbargoManagementPageDataService {
  apiEP: string = window.sellsideApiUrl;

  constructor(private http: HttpClient) {}

  getData = (
    pageOffset: number,
    pageLimit: number,
    buysideKeyword: string,
    brokerKeyword: string,
    sortBy: string,
    sortOrder: string,
  ) => {
    const queries = [
      `pageoffset=${pageOffset}`,
      `pagelimit=${pageLimit}`,
      `buyside_keyword=${encodeURIComponent(buysideKeyword)}`,
      `broker_keyword=${encodeURIComponent(brokerKeyword)}`,
      `sortby=${sortBy}`,
      `sortorder=${sortOrder}`,
    ];

    return this.http.get(
      `${this.apiEP}/sellside/embargo/details?${queries.join("&")}`,
    );
  };

  getFirmList = (type: string, name: string) => {
    const queries = [`type=${type}`, `name=${encodeURIComponent(name)}`];

    return this.http.get(
      `${this.apiEP}/sellside/firmlist?${queries.join("&")}`,
    );
  };

  postEmbargoDetails = (
    type: number,
    buysideId: number,
    brokerId: number,
    modelData: number,
    modelDownload: number,
    researchDownload: number,
  ) => {
    const jsonData = {
      insert: type,
      buyside_id: buysideId,
      broker_id: brokerId,
      embargo_days: {
        model_data: modelData,
        model_download: modelDownload,
        research_download: researchDownload,
      },
    };
    return this.http.post(`${this.apiEP}/sellside/embargo/details`, jsonData);
  };

  deleteEmbargoDetails(data) {
    const options = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
      body: data,
    };
    return this.http.delete(`${this.apiEP}/sellside/embargo/details`, options);
  }

  exportEmbargo(jsonData: any): Observable<any> {
    const options = {
      observe: "response" as "body",
      responseType: "blob" as "json",
    };
    return this.http.post<HttpResponse<any>>(
      `${this.apiEP}/sellside/embargo/export`,
      jsonData,
      options,
    );
  }

  getEmbargoHistory = (
    brokerId: number,
    buysideId: number,
    pageoffset: number,
    pagelimit: number,
  ) => {
    const queries = [
      `broker_id=${brokerId}`,
      `buyside_id=${buysideId}`,
      `pageoffset=${pageoffset}`,
      `pagelimit=${pagelimit}`,
    ];

    return this.http.get(
      `${this.apiEP}/sellside/embargo/history?${queries.join("&")}`,
    );
  };
}
